/* CreateComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./CreateRenderer");

class CreateComponent extends EventEmitter {
    constructor(logger, odmOsPlatform, previousFormData, fieldOptions) {
        super();
        this._logger = logger;
        this._odmOsPlatform = odmOsPlatform;
        this._previousFormData = previousFormData;
        this._fieldOptions = fieldOptions || {};
        this._renderer = new Renderer(this, previousFormData, fieldOptions);
        this._renderer.render();
    }

    get renderer() {
        return this._renderer;
    }

    get logger() {
        return this._logger;
    }

    get previousFormData() {
        return this._previousFormData;
    }

    get fieldOptions() {
        return this._fieldOptions;
    }

    get odmOsPlatform() {
        return this._odmOsPlatform;
    }

    /**
     * Creates a platform with the provided form data.
     * Handles entity property setting and API call.
     * @param {Object} formData - Form field values
     * @returns {Promise} Promise that resolves with platform creation result
     */
    createPlatform(formData) {
        // Set all platform properties from form data
        this._odmOsPlatform.name = formData.name;
        this._odmOsPlatform.manufacturer = formData.manufacturer || undefined;
        this._odmOsPlatform.model = formData.model || undefined;
        this._odmOsPlatform.deviceType = formData.deviceType || undefined;
        this._odmOsPlatform.osName = formData.osName || undefined;
        this._odmOsPlatform.osFamily = formData.osFamily || undefined;
        this._odmOsPlatform.osReleaseName = formData.osReleaseName || undefined;
        this._odmOsPlatform.osVersion = formData.osVersion || undefined;
        this._odmOsPlatform.machineArchitecture = formData.machineArchitecture || undefined;
        this._odmOsPlatform.language = formData.language || undefined;
        this._odmOsPlatform.locale = formData.locale || undefined;
        this._odmOsPlatform.description = "";

        // Create the platform via API
        return this._odmOsPlatform.create();
    }

    shutdown() {
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._odmOsPlatform = undefined;
                this._renderer = undefined;
                this._previousFormData = undefined;
                this._fieldOptions = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "CreateComponent.shutdown() error");
            }
        );
    }

    createAction(formData) {
        this._context.resolve(formData);
    }

    cancelAction() {
        this._context.reject({userRejected: true});
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }
}

module.exports = CreateComponent;
